<ng-template #loading class="d-flex justify-content-center align-items-center h-100 w-100 pt-4">
  <mat-spinner class="mt-4 loading-spinner"></mat-spinner>
</ng-template>

<div class="top-container w-100 h-100">
  <ng-container *ngIf="leadingOfferInfo != null">
    <div class="d-flex w-100 h-100 flex-column" style="overflow: hidden">
      <div class="d-flex align-items-center gap-2">
        <span class="open-all-label">
          {{(!allExpandState ? 'createOffer.openDetails' : 'createOffer.closeDetails') | translate}}
        </span>
        <mat-slide-toggle [(ngModel)]="allExpandState"
                          (ngModelChange)="clickButton($event)"></mat-slide-toggle>
      </div>
      <mat-accordion class="accordion-container" [multi]="true" displayMode="flat">
        <mat-expansion-panel [togglePosition]="'before'">
          <mat-expansion-panel-header [@.disabled]="true">
            <mat-panel-title>
              {{'offer.managementBusiness' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.share' | translate}} ({{'offer.inPercent' | translate}}):</div>
            <div>{{leadingOfferInfo.amountCovered |percent: '1.2-2'}}
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel [togglePosition]="'before'">
          <mat-expansion-panel-header [@.disabled]="true">
            <mat-panel-title>
              {{'offer.premium' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div *ngIf="leadingOfferInfo.premiumInPercent != 0" class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.inPercent' | translate}}:</div>
            <div>{{leadingOfferInfo.premiumInPercent |percent: '1.2-2'}}</div>
          </div>
          <div *ngIf="leadingOfferInfo.premiumPerThousand != 0" class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.perThousand' | translate}}:</div>
            <div>{{leadingOfferInfo.premiumPerThousand |permilleFormat}}</div>
          </div>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.premium' | translate}}:</div>
            <div>{{leadingOfferInfo.premium |currency:leadingOfferInfo.currency}}</div>
          </div>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'offer.expectedTotalPremium' | translate}}:</div>
            <div>{{leadingOfferInfo.expectedTotalPremium |currency:leadingOfferInfo.currency}} </div>
          </div>
          <div class="d-flex proposal-details-row" *ngIf="leadingOfferInfo.advancePremium">
            <div class="info-col">{{'offer.advancePremium' | translate}}:</div>
            <div *ngIf="leadingOfferInfo.advancePremium">{{leadingOfferInfo.advancePremium |currency:leadingOfferInfo.currency}}</div>
          </div>
          <div class="d-flex proposal-details-row" *ngIf="leadingOfferInfo.minimumPremium">
            <div class="info-col">{{'offer.minimumPremium' | translate}}:</div>
            <div *ngIf="leadingOfferInfo.minimumPremium">{{leadingOfferInfo.minimumPremium |currency:leadingOfferInfo.currency}}</div>
          </div>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'proposalDetails.createOfferTab.typeOfDeductible' | translate}}:</div>
            <div
              *ngIf="leadingOfferInfo.typeOfDeductible">{{"proposalDetails.createOfferTab.typeOfDeductibleOptions." + leadingOfferInfo.typeOfDeductible | translate }}</div>
          </div>
          <div *ngIf="leadingOfferInfo.typeOfDeductible != QuestionOptions.typeOfDeductible[0]" class="d-flex proposal-details-row">
            <div class="info-col">{{'proposalDetails.createOfferTab.deductibleAbsoluteAmount' | translate}}:</div>
            <div>{{leadingOfferInfo.deductibleAbsoluteAmount |currency:leadingOfferInfo.deductibleCurrency }}</div>
          </div>
        </mat-expansion-panel>
        <hr>

        <ng-container>
          <mat-expansion-panel [disabled]="leadingOfferInfo.standardTermsAndConditions?.length == 0" [togglePosition]="'before'">
            <mat-expansion-panel-header [@.disabled]="true">
              <mat-panel-title>
                {{'offer.defaultTerms' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="pre-wrap" *ngIf="leadingOfferInfo.standardTermsAndConditions?.length">
              - {{leadingOfferInfo.standardTermsAndConditions.join('\n - ')}}
            </div>
          </mat-expansion-panel>
          <hr>
          <mat-expansion-panel [disabled]="leadingOfferInfo.individualTermsAndConditions?.length == 0" [togglePosition]="'before'">
            <mat-expansion-panel-header [@.disabled]="true">
              <mat-panel-title>
                {{'offer.individualTerms' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="pre-wrap">{{leadingOfferInfo.individualTermsAndConditions}}
            </div>
          </mat-expansion-panel>
          <hr>
          <mat-expansion-panel [disabled]="leadingOfferInfo.standardClauses?.length == 0" [togglePosition]="'before'">
            <mat-expansion-panel-header [@.disabled]="true">
              <mat-panel-title>
                {{'offer.defaultClauses' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="pre-wrap" *ngIf="leadingOfferInfo.standardClauses?.length">
              - {{leadingOfferInfo.standardClauses.join('\n - ')}}
            </div>
          </mat-expansion-panel>
          <hr>
          <mat-expansion-panel [disabled]="leadingOfferInfo.individualClauses?.length == 0" [togglePosition]="'before'">
            <mat-expansion-panel-header [@.disabled]="true">
              <mat-panel-title>
                {{'offer.individualClauses' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="pre-wrap">{{leadingOfferInfo.individualClauses}}
            </div>
          </mat-expansion-panel>

          <hr class="line">
        </ng-container>

      </mat-accordion>
    </div>

  </ng-container>
</div>
